import React from "react";

const Footer = () => {
    return (
        <footer>
            <div className="footer container">
                <div className="corp-name">
                    <span className="name-en">mobili car</span>
                    <span className="name-kr">주식회사 모빌리카</span>
                </div>
                <div className="corp-info">
                    <div className="info-detail">
                        <div className="item">
                            <span className="item-tit">주소</span>
                            <span className="item-desc">서울특별시 송파구 법원로 114, 비동 8층 809호(문정동, 엠스테이트)</span>
                        </div>
                        <div className="item">
                            <span className="item-tit">대표자</span>
                            <span className="item-desc">박정근</span>
                        </div>
                        <div className="item">
                            <span className="item-tit">사업자등록번호</span>
                            <span className="item-desc">274-88-03644</span>
                        </div>
                        <div className="item">
                            <span className="item-tit">대표번호</span>
                            <span className="item-desc">1800-6586</span>
                        </div>
                        <div className="item">
                            <span className="item-tit">E-mail</span>
                            <span className="item-desc">info@mobilicar.kr</span>
                        </div>
                    </div>

                    <div className="terms">
                        <ul>
                            <li>
                                <a href="https://immense-property-46a.notion.site/1d0b1cacbbd580ae9393c7e0000fc2e9?pvs=4" target="_blank">
                                    서비스 이용약관
                                </a>
                            </li>
                            <li>
                                <a href="https://immense-property-46a.notion.site/1c2b1cacbbd58096b194cbce0b4f27b9?pvs=4" target="_blank">
                                    개인정보 처리방침
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="copyright">
                        <span>@2025 Mobilicar Co., Ltd. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
